import { useMemo } from "react";
import {
  AssessmentGroupDelivery,
  AssessmentSubmissionNodeType,
  ComplianceProgramParticipantStatus,
  RelatedAssessmentSubmissionFragment,
} from "types/graphql-schema";

import StatusPill from "@components/status-pill/status-pill";
import { StatusPillEnum } from "@components/status-pill/status-pill-constants";

const RelatedSubmissionStatusPill = ({
  submission,
}: {
  submission: RelatedAssessmentSubmissionFragment;
}) => {
  const statusLabel = useMemo(() => {
    if (submission.type === AssessmentSubmissionNodeType.PeerNominations) {
      return `${submission.completeCount} Nominated`;
    } else if (submission.type === AssessmentSubmissionNodeType.Calibration) {
      return submission.status === ComplianceProgramParticipantStatus.Complete
        ? "Calibrated"
        : "Not Calibrated";
    } else if (submission.type === AssessmentSubmissionNodeType.Delivery) {
      return submission.status === ComplianceProgramParticipantStatus.Complete
        ? "Shared"
        : submission.status === ComplianceProgramParticipantStatus.InProgress
          ? "Approved"
          : submission.template?.delivery ===
              AssessmentGroupDelivery.AdminApproval
            ? "Not Approved"
            : "Not Shared";
    } else if (
      [
        AssessmentSubmissionNodeType.SelfAssessment,
        AssessmentSubmissionNodeType.ManagerAssessment,
      ].includes(submission.type)
    ) {
      if (submission.status === ComplianceProgramParticipantStatus.Complete) {
        return "Complete";
      }
      return submission.pendingCount > 0 ? "In Progress" : "N/A";
    } else {
      return submission.completeCount + submission.pendingCount > 0
        ? `${submission.completeCount}/${
            submission.completeCount + submission.pendingCount
          } Complete`
        : "N/A";
    }
  }, [submission]);
  return (
    <StatusPill
      label={statusLabel}
      status={
        submission.status === ComplianceProgramParticipantStatus.Complete
          ? StatusPillEnum.Complete
          : submission.status === ComplianceProgramParticipantStatus.InProgress
            ? StatusPillEnum.InProgress
            : StatusPillEnum.NotApplicable
      }
    />
  );
};

export default RelatedSubmissionStatusPill;
